<template>
	<div class="cd-images" :class="{'age-verification': item.xxx && !isAdult}">
		<template v-if="!itemUpdate">
			<div v-if="item?.all_images?.length > 1 && !mobileBreakpoint" class="cd-thumbs cd-thumbs-slider">
				<template v-for="(thumb, index) in item?.all_images.slice(0, maxImages)" :key="thumb.id">
					<div class="cd-thumb cd-thumb-image" v-if="thumb.file_thumb_small" @click="openGallery(index)">
						<BaseUiImage :data="thumb?.file_thumb_small" default="/images/no-image.jpg" />
						<span v-if="index == maxImages - 1 && item?.all_images.length > maxImages" class="cd-thumb-more">
							<span>
								<span>+{{ item?.all_images.length - maxImages}}</span>
								<template v-if="item?.all_images.length - maxImages > 1 && item?.all_images.length - maxImages < 5"> slike</template>
								<template v-else> slika</template>
							</span>
						</span>
					</div>
				</template>
				<template v-if="videos?.length">
					<div class="cd-thumb cd-thumb-video" @click="openGallery(item.all_images.length)">
						<BaseUiImage :data="item?.all_images[0]?.file_thumb_small" default="/images/no-image.jpg" />
						<span class="cd-thumb-more">
							<span>
								<span>{{ videos.length }}</span>
								<template v-if="videos.length == 1"> video</template>
								<template v-else> videa</template>
							</span>
						</span>
					</div>
				</template>
			</div>

			<div class="cd-hero-image" :class="{'no-image': !item?.all_images?.length}">
				<CatalogProductBadges :item="item" :types="['image']" />
				<template v-if="item?.all_images?.length">
					<BaseUiSwiper
						class="cd-hero-slider"
						name="hero"
						:options="{
							slidesPerView: 1,
							effect: 'fade',
							pagination: {
								enabled: true,
								clickable: true,
							}
						}">
						<template v-for="(file, index) in item.all_images" :key="index">
							<BaseUiSwiperSlide v-if="file?.file_thumb" class="cd-hero-slide" rel="noreferrer" @click="openGallery(index)">
								<BaseUiImage :loading="index == 0 ? 'eager' : 'lazy'" :data="file?.file_thumb" default="/images/no-image.jpg" />
								<span v-if="file.state == 'd'" class="btn-image-state" :class="{'special': item?.check_lists && item?.check_lists?.['webcatalog_3d-ar']}"><BaseCmsLabel code="condition_images_badge" tag="span" /></span>
							</BaseUiSwiperSlide>
						</template>
						<template v-if="videos?.length">
							<BaseUiSwiperSlide v-for="(video, index) in videos" :key="index" class="cd-hero-slide cd-hero-video" rel="noreferrer" @click="openGallery(item.all_images.length)">
								<video controls :src="absolute(video.url)" />
							</BaseUiSwiperSlide>
						</template>
					</BaseUiSwiper>
					<ClientOnly>
						<!-- wishlist -->
						<div class="cd-icons-top-right">
							<CmsShare />
							<CatalogSetWishlists :item="item" mode="detail" />
							<CatalogSetCompare :item="item" mode="detail" />
						</div>

						<!-- energy -->
						<div v-if="energyAttr?.length" class="cd-energy" :class="{'link': item?.energy_image_upload_path}" @click="(item?.energy_image_upload_path) ? openModal('flyout', {header: true, title: labels.get('energy_flyout_title'), content: '<img src='+absolute(item?.energy_image_upload_path)+' />'}) : null">
							<div class="cd-energy-item" v-for="energy in energyAttr" :key="energy.id">
								<BaseUiImage v-if="energy.image_upload_path" :src="energy.image_upload_path" width="60" height="32" default="/images/no-image.jpg" :alt="energy.title" />
								<template v-else>{{ energy.title }}</template>
							</div>
						</div>

						<!-- 3d button -->
						<LazyCatalogWebcatalog3d :item="item" v-if="!mobileBreakpoint && item?.check_lists" />
					</ClientOnly>
				</template>
				<template v-else>
					<img class="no-image" loading="lazy" src="/images/no-image.jpg" :title="item.seo_h1" :alt="item.seo_h1" />
				</template>
			</div>
		</template>
		<template v-else>
			<div class="cd-hero-image no-image loading">
				<UiLoader class="small" />
			</div>
		</template>
	</div>

	<ClientOnly>
		<Teleport to="body">
			<LazyCatalogGalleryModal v-if="Object.keys(activeModals()).includes('gallery-modal')" />
		</Teleport>
	</ClientOnly>
</template>

<script setup>
	const config = useAppConfig();
	const {mobileBreakpoint} = inject('rwd');
	const {open: openModal, activeModals} = useModal();
	const {absolute} = useUrl();
	const props = defineProps(['item', 'loadingItemData']);
	const labels = useLabels();
	const {energyAttr, imageBadges} = useProductData(props.item);
	const {openAgeModal, isAdult} = useAgeVerification();

	function openGallery(index) {
		const images = (props.item?.all_images?.length) ? props.item.all_images : [];
		const videos = props.item?.documents?.filter(image => image.kind == 'video') || [];
		if(!images?.length && !videos?.length) return;
		openModal('gallery-modal', {
			startIndex: index,
			items: [...images, ...videos],
		});
	}

	const videos = computed(() => props.item?.documents?.filter(image => image.kind == 'video') || []);
	const maxImages = computed(() => videos.value.length ? 4 : 5);

	const itemUpdate = ref(false);
	watch(
		() => props.item,
		() => {
			itemUpdate.value = true;
			setTimeout(() => {
				itemUpdate.value = false;
			}, 100);
		}
	);
</script>


<style lang="less" scoped>
	//swiper
	:deep(.swiper-button){
		display: flex; align-items: center; justify-content: center; width: 46px; height: 46px; background: var(--white); border-radius: 100%; font-size: 0; line-height: 0; position: absolute; left: 110px; top: 50%; transform: translateY(-50%); z-index: 1; cursor: pointer; .transition(background); box-shadow: 0px 0.764px 3.055px 0px rgba(0, 0, 0, 0.25);
		&:before{.icon-arrow-down(); margin-right: 4px; font: 14px/1 var(--fonti); color: var(--gray5); position: absolute; z-index: 1; .rotate(90deg); .transition(color);}

		@media (max-width: @l){left: 16px;}
	}
	@media (max-width: @m){
		:deep(.swiper-navigation){display: none;}
	}
	:deep(.swiper-button-next){
		left: unset; right: 110px; transform: translateY(-50%);
		&:before{margin: 0 0 0 4px; .rotate(-90deg);}

		@media (max-width: @l){left: unset; right: 16px;}
	}
	:deep(.swiper-button-disabled){display: none;}

	:deep(.swiper-pagination){
		display: none;
		.swiper-pagination-bullet{border: 1px solid var(--gray5); border-radius: 100px; width: 10px; height: 10px; background: #fff;}
		.swiper-pagination-bullet-active{background: var(--blueDark); border-color: var(--blueDark);}
		@media (max-width: @m){display: inline-flex; gap: 5px; align-items: center; justify-content: center; position: absolute; bottom: 17px; left: 50%; transform: translateX(-50%); z-index: 1;}
	}
	:deep(.hero-swiper-dot){
		@media (max-width: @m){
			display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 10px; height: 10px; margin: 0 3px; background: var(--white); border: 1px solid var(--gray5); border-radius: 100%; z-index: 1; .transition(all);
			&.is-active{background: var(--blueDark); border-color: var(--blueDark);}
		}
	}

	.badges{
		position: absolute; top: 15px; left: 17px; width: 46px; z-index: 10; display: flex; flex-direction: column; gap: 10px;
		:deep(img){display: block; width: 100%;}
	}

	//images
	.cd-images{
		display: flex; height: 546px; margin-bottom: 24px;

		@media (max-width: @m){height: 280px; margin: 0;}
	}
	.cd-thumbs{
		width: 98px; max-height: 546px; flex-shrink: 0; margin-right: 24px;
		@media (max-width: @m){display: none!important;}
	}
	.cd-thumb{
		display: flex; align-items: center; position: relative; justify-content: center; flex-shrink: 0; width: 98px; height: 98px; margin-bottom: 14px; background: var(--white); border-radius: var(--borderRadius); overflow: hidden; cursor: pointer; overflow: hidden;
		:deep(img){display: block; width: auto; height: auto; max-width: 80%; max-height: 80%;}
	}
	.cd-thumb-more{display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.6); border-radius: 12px; font-size: 15px; font-weight: 600; color: var(--white); position: absolute; top: 0; bottom: 0; left: 0; right: 0; z-index: 1; text-align: center;}
	.cd-thumb-image .cd-thumb-more{
		span{display: block; line-height: 1.2;}
		span span{font-size: 24px; display: block;}
	}
	.cd-thumb-video .cd-thumb-more{
		&>span{
			position: relative;
			&:before{.icon-play(); font: 26px/1 var(--fonti); color: #fff; display: block; margin-bottom: 5px;}
		}
	}
	
	.cd-hero-image{
		width: 830px; background: var(--white); border-radius: var(--borderRadius); position: relative; overflow: hidden; flex-grow: 1;
		&.no-image{display: flex; align-items: center; justify-content: center;}

		@media (max-width: @l){width: 578px;}
		@media (max-width: @t){width: 428px;}
		@media (max-width: @m){width: 100%; border-radius: 0;}
	}
	.cd-hero-slide{
		display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer; position: relative;
		a{display: flex; align-items: center; justify-content: center;}
		:deep(img){
			display: block; width: auto; height: auto; max-width: 90%; max-height: 90%;
			@media (max-width: @m){max-height: 220px;}
		}
		&:after{
			.pseudo(45px,45px); .icon-zoomIn(); color: #6D6D6D; opacity: 0; font: 45px/1 var(--fonti); display: flex; align-items: center; justify-content: center; background: #fff; border-radius: 100px; box-shadow: 0px 0.65px 2.61px 0px #00000040;
			@media (max-width: @m){display: none;}
		}
		&:hover:after{opacity: 1;}
	}
	.cd-hero-slider{
		height: 100%;
		:deep(.swiper){height: 100%;}
	}
	.no-image{
		display: block; width: auto; height: auto; max-width: 100%; max-height: 100%; border-radius: 12px;

		@media (max-width: @m){border-radius: 0;}
	}
	.btn-image-state{
		position: absolute; bottom: 20px; left: 20px; background: var(--yellow); padding: 5px 10px; border-radius: 8px; font-size: 14px; color: #fff; z-index: 30;
		@media (max-width: @m){font-size: 12px; border-radius: 5px; padding: 3px 8px; bottom: 32px;}
	}

	//images icons/badges
	.cd-icons-top-right{
		position: absolute; top: 16px; right: 16px; z-index: 1; display: flex; gap: 13px; flex-direction: column;
		@media (max-width: @m){top: 12px; right: 12px; gap: 8px;}
	}
	.cd-energy{
		display: flex; align-items: center; justify-content: center; position: absolute; left: 16px; bottom: 16px; font-size: 14px; color: var(--black); z-index: 1; gap: 5px;
		&.link{cursor: pointer;}
		:deep(img){display: block; width: auto; height: auto; max-width: 60px; max-height: 32px;}

		@media (max-width: @m){
			left: 15px; bottom: 12px; font-size: 12px;
			:deep(img){max-width: 40px; max-height: 22px;}
		}
	}
	video{width: 80%; height: 80%; display: block;}
	.age-verification :deep(img){filter: blur(20px);}
	.age-verification .cd-thumb :deep(img){filter: blur(7px);}
</style>